// extracted by mini-css-extract-plugin
export default {"infoSection":"MinistryUsedStampsList_infoSection__9h+Nu","descriptions":"MinistryUsedStampsList_descriptions__-+Tn+"};